import { useCollectionsStateContext } from '../../components/CollectionStateProvider';

export const useIsCollectionOpen = (id: string) => {
  const { collectionsState } = useCollectionsStateContext();
  return collectionsState[id] ?? true;
};
